import React, { useState } from 'react';
import { IntegrationItem } from '../../../../../shared/ui';
import { IconMap } from '../../../../../shared/sprite';
import { GongIntegrationModal } from './GongIntegrationModal';
import { useDispatch, useSelector } from 'react-redux';
import { teamsModel } from '../../../../teams';
import { DisconnectGongConfirmationModal } from './DisconnectGongConfirmationModal';
import { gongModel } from '../../../../../entities/gong';
import { GongDetailsModal } from './GongDetailsModal';

export const GongIntegration: React.FC = () => {
  const [isIntegrationModalOpen, setIntegrationModalOpen] = useState(false);
  const [isDetailsModalOpen, setDetailsModalOpen] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const isGongConnected = currentTeam.isGongConnected;

  const dispatch = useDispatch();

  const handleDisconnectFromGong = () => {
    dispatch(
      gongModel.actions.deleteGongTeamSecrets({
        cb: () => setConfirmationModalOpen(false),
      })
    );
  };

  return (
    <>
      <GongIntegrationModal
        isOpen={isIntegrationModalOpen}
        onClose={() => setIntegrationModalOpen(false)}
      />
      <GongDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={() => setDetailsModalOpen(false)}
      />
      <DisconnectGongConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
        onConfirm={handleDisconnectFromGong}
      />
      <IntegrationItem
        icon={IconMap.GongLg}
        title="Gong"
        description="Utilize call transcription to identify obstacles and effortlessly generate tailored pages for your client with the help of Create with AI Distribute feature."
        buttonText={isGongConnected ? 'Disconnect' : 'Connect'}
        onClick={() =>
          isGongConnected
            ? setConfirmationModalOpen(true)
            : setIntegrationModalOpen(true)
        }
        isDisconnect={isGongConnected}
        hasSecondaryBtn={isGongConnected}
        secondaryButtonText="Learn more"
        onSecondaryBtnClick={() => setDetailsModalOpen(true)}
      />
    </>
  );
};
